import { Button, Divider, Stack, Typography, useTheme } from "@mui/material";
import { Icon } from "@iconify/react";

import { Strings } from "@app/constants";
import { sellCarDummyData } from "../sellCarDummyData";
import { useRequestState } from "@app/hooks";
import { selectBrandState } from "@app/modules/categories/selector";

export const CarValuation = ({
  onBack,
  methods,
  handleSubmit,
  formWatchedValues,
}: any) => {
  const theme = useTheme();

  const data = sellCarDummyData;

  const { data: selectBrandData } = useRequestState({
    stateSelector: selectBrandState,
  });

  const filteredBrand = selectBrandData?.find(
    (brand: any) => brand.id === formWatchedValues?.brandId,
  );

  const filteredModel = filteredBrand?.models?.find(
    (model: any) => model.id === formWatchedValues?.modelId,
  );

  const renderCardItem = (key: string, value: string) => {
    return (
      <>
        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
        >
          <Typography>{key}</Typography>
          <Typography>{value}</Typography>
        </Stack>
      </>
    );
  };
  return (
    <>
      <Stack direction="column" alignItems="center" spacing={1}>
        <Icon
          icon={"weui:done2-filled"}
          color={theme.palette.success.main}
          fontSize={68}
        />
        <Typography variant="h5" textAlign={"center"}>
          {Strings.step.carValuation.carValuationSummary}
        </Typography>
        <Typography textAlign={"center"}>
          {Strings.step.carValuation.reviewYourDetailsAndEstimatedPrice}
        </Typography>
      </Stack>

      <Stack
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent={"space-between"}
        mt={4}
        gap={2}
        flexWrap={"wrap"}
      >
        <Stack
          sx={{ flex: 1, minWidth: 200 }}
          border={1}
          borderRadius={2}
          p={2}
        >
          <Typography textAlign={"center"} fontWeight={600}>
            {Strings.step.carValuation.vehicleInformation}
          </Typography>
          {renderCardItem(
            Strings.step.carValuation.carNumber,
            formWatchedValues?.carNumber,
          )}
          {renderCardItem(
            Strings.step.carValuation.brand,
            filteredBrand?.name || "",
          )}
          {renderCardItem(
            Strings.step.carValuation.model,
            filteredModel?.name || "",
          )}
          {renderCardItem(
            Strings.step.carValuation.year,
            formWatchedValues?.year,
          )}
        </Stack>

        <Stack
          sx={{ flex: 1, minWidth: 200 }}
          border={1}
          borderRadius={2}
          p={2}
        >
          <Typography textAlign={"center"} fontWeight={600}>
            {Strings.step.carValuation.specification}
          </Typography>
          {renderCardItem(
            Strings.step.carValuation.fuelType,
            formWatchedValues?.engineType,
          )}
          {renderCardItem(
            Strings.step.carValuation.transmission,
            formWatchedValues?.transmission,
          )}
          {renderCardItem(
            Strings.step.carValuation.variant,
            formWatchedValues?.variant,
          )}
          {renderCardItem(
            Strings.step.carValuation.kilometers,
            formWatchedValues?.KmDriven,
          )}
        </Stack>

        <Stack
          sx={{ flex: 1, minWidth: 200 }}
          border={1}
          borderRadius={2}
          p={2}
        >
          <Typography textAlign={"center"} fontWeight={600}>
            {Strings.step.carValuation.sellingDetails}
          </Typography>
          {renderCardItem(
            Strings.step.carValuation.sellTimeline,
            formWatchedValues?.selectedSellingTime,
          )}
          {renderCardItem(
            Strings.step.carValuation.phoneNumber,
            formWatchedValues?.mobileInfo?.phoneNumber,
          )}
        </Stack>
      </Stack>

      <Stack
        width={"80%"}
        alignSelf={"center"}
        py={3}
        mt={3}
        px={2}
        sx={{
          backgroundColor: theme.palette.primary.main,
          alignItems: "center",
          borderRadius: 1,
        }}
      >
        <Typography
          color={theme.palette.common.white}
          sx={{ textAlign: "center", fontWeight: 600 }}
        >
          {Strings.step.carValuation.finalPriceSubjectToPhysicalInspection}
        </Typography>
      </Stack>

      <Stack>
        <Stack
          border={`1px solid ${theme.palette.grey[200]}`}
          mt={3}
          p={2}
          borderRadius={1}
          flexDirection={"row"}
          gap={2}
        >
          <Stack
            borderRadius={"50%"}
            border={`1px solid ${theme.palette.primary.main}`}
            width={60}
            height={60}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Icon
              style={{
                fontSize: "2rem",
              }}
              icon={"mage:message-round-fill"}
              color={theme.palette.primary.main}
            />
          </Stack>
          <Stack>
            <Typography
              sx={{ color: theme.palette.primary.main, fontWeight: 600 }}
            >
              {Strings.step.carValuation.confirmation}
            </Typography>
            <Typography variant="body2">
              {Strings.step.carValuation.ourTeamWillCallYouShortly}
            </Typography>
          </Stack>
        </Stack>
        <Stack
          border={`1px solid ${theme.palette.grey[200]}`}
          mt={3}
          p={2}
          borderRadius={1}
          flexDirection={"row"}
          gap={2}
        >
          <Stack
            borderRadius={"50%"}
            border={`1px solid ${theme.palette.primary.main}`}
            width={60}
            height={60}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Icon
              style={{
                fontSize: "2rem",
              }}
              icon={"eos-icons:service-instance"}
              color={theme.palette.primary.main}
            />
          </Stack>
          <Stack>
            <Typography
              sx={{ color: theme.palette.primary.main, fontWeight: 600 }}
            >
              {Strings.step.carValuation.serviceAvailability}
            </Typography>
            <Typography variant="body2">
              {Strings.step.carValuation.thisServiceIsOnlyAvailable}
            </Typography>
            <Typography variant="body2">
              {Strings.step.carValuation.only1stOwnerCarsAre}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Stack flexDirection={"row"} gap={2} mt={5} justifyContent={"center"}>
        <Button style={{ width: 200 }} variant="outlined" onClick={onBack}>
          {Strings.button.goBack}
        </Button>
        <Button
          style={{ width: 200 }}
          variant="contained"
          onClick={methods.handleSubmit(handleSubmit)}
        >
          {Strings.button.submit}
        </Button>
      </Stack>
    </>
  );
};
